module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_0.df3f107b.png";